export function prizmToInt(bool: boolean): 1 | 0 {
  return bool ? 1 : 0;
}
